import React from "react";
import { Box, IconButton, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import { GitHub, LinkedIn } from "@mui/icons-material";
import vsDarkTheme from "../theme/vsDarkTheme";

const SocialIcons = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      gap: { xs: 0.5, sm: 1 }, 
      mt: { xs: 1, sm: 2 } 
    }}>
      <Tooltip title="GitHub" placement="top">
        <IconButton
          href="https://github.com/victro-rios"
          target="_blank"
          rel="noopener noreferrer"
          size={isMobile ? "small" : "medium"}
          sx={{
            color: vsDarkTheme.palette.text.primary,
            '&:hover': {
              color: vsDarkTheme.palette.primary.main,
            }
          }}
        >
          <GitHub fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Tooltip>
      <Tooltip title="LinkedIn" placement="top">
        <IconButton
          href="https://linkedin.com/in/victor-hugo-rios-rada"
          target="_blank"
          rel="noopener noreferrer"
          size={isMobile ? "small" : "medium"}
          sx={{
            color: vsDarkTheme.palette.text.primary,
            '&:hover': {
              color: vsDarkTheme.palette.primary.main,
            }
          }}
        >
          <LinkedIn fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SocialIcons;
